module.exports = __webpack_public_path__ + "infocentrum3.jpg?242ed92d35795d96a89649fb9f5cfe0b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/infocentrum/infocentrum3.jpg
// module id = 255
// module chunks = 0